import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notification-wrapper" }
const _hoisted_2 = ["innerHTML"]

import { onMounted, ref, watch } from 'vue';
import { useNotificationStore } from '@/stores/notification.store';
import {
  INotification,
  NotificationDisplayDuration,
  NotificationDisplayTiming,
} from '@/types/notificationTypes';
import { Fade } from '@progress/kendo-vue-animation';
import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
import { useDebounceFn } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  setup(__props) {

const notificationStore = useNotificationStore();
const activeNotifications = ref<INotification[]>([]);

const onClose = (notification: INotification) => {
  activeNotifications.value = activeNotifications.value.filter((n) => n !== notification);
  notificationStore.removeNotification(notification);
};

const doRemoveOnceDisplayed = (notifications: INotification[]) => {
  notifications
    .filter((n) => n.displayDuration === NotificationDisplayDuration.Once)
    .forEach((n) => {
      notificationStore.removeNotification(n);
    });
};

const removeOnceDisplayedDebounced = useDebounceFn(async (notifications: INotification[]) => {
  doRemoveOnceDisplayed(notifications);
}, 500);

onMounted(async () => {
  const refreshNotifications = notificationStore.notifications.filter(
    (n) => n.displayTiming === NotificationDisplayTiming.AfterPageRefresh,
  );

  activeNotifications.value.push(...refreshNotifications);

  await removeOnceDisplayedDebounced(refreshNotifications);
});

watch(
  () => notificationStore.notifications,
  async (newList) => {
    const alreadyVisibleMessages = new Set(activeNotifications.value.map((n) => n.message));

    const immediateToShow = newList.filter(
      (n) =>
        n.displayTiming === NotificationDisplayTiming.Immediately &&
        !alreadyVisibleMessages.has(n.message),
    );

    if (immediateToShow.length) {
      activeNotifications.value.push(...immediateToShow);
      await removeOnceDisplayedDebounced(newList);
    }
  },
  { deep: true, immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NotificationGroup), null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeNotifications.value, (notification) => {
          return (_openBlock(), _createBlock(_unref(Fade), {
            key: notification.message,
            appear: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Notification), {
                type: {
            style: notification.type,
            icon: true,
          },
                closable: true,
                onClose: ($event: any) => (onClose(notification))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: notification.message
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["type", "onClose"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})